import { can } from '../utils/rights';

export default [
  {
    path: '/dashboard',
    view: 'Dashboard',
    client: 'komacut'
  },
  {
    path: '/rfqs',
    view: 'RFQS',
    client: 'komacut',
    hidden: async () => !(await can('rfq', 'read')),
  },
  // {
  //   path: '/rfqs/new',
  //   view: 'EditRFQ',
  //   client: 'komacut',
  //   hidden: async () => !(await can('newRfq', 'read')),
  // },
  {
    path: '/rfqs/:id',
    view: 'EditRFQ',
    client: 'komacut',
    name: 'EditRFQ',
    hidden: async () => !(await can('newRfq', 'read')),
  },
  {
    path: '/orders',
    view: 'Orders',
    client: 'komacut',
    hidden: async () => !(await can('order', 'read')),
  },
  {
    path: '/orders/new',
    view: 'NewOrder',
    client: 'komacut',
    hidden: async () => !(await can('newOrder', 'read')),
  },
  {
    path: '/my_parts',
    view: 'MyParts',
    client: 'komacut',
    hidden: async () => !(await can('my_parts', 'read')),
  },
  {
    path: '/settings',
    view: 'Settings',
    client: 'komacut',
    hidden: async () => !(await can('settings', 'read')),
  },
  {
    path: '/engineering_tools',
    view: 'EngineeringTools',
    client: 'komacut',
    hidden: async () => !(await can('engineering_tools', 'read')),
  },
];
